import { AllPalletCapacityResponseModel, PalletCapacityResponseModel } from '@gtpl/shared-models/masters';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { PalletCapacityDTO } from './dto/pallet-capacity.dto';
import { PalletCapacityRequest } from './dto/pallet-capacity.request';
import { PalletCapacityService } from './pallet-capacity.service';

@Controller('pallet-capacity')
@ApiTags('pallet-capacity')
export class PalletCapacityController {
    constructor(
        private palletCapacityService: PalletCapacityService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
      ) {}

      /**
     * creates or updates a value of Packing Methods
     * @param PalletCapacityDto packing Method DTO
     * @returns packing MethodResponse
     */
    @Post('/createPalletCapacity')
    async createPalletCapacity(@Body() PalletCapacityDto:PalletCapacityDTO,isUpdate:boolean=false,@Req() request:Request): Promise<PalletCapacityResponseModel> {
        try {
         return await this.palletCapacityService.createPalletCapacity(PalletCapacityDto,false,request);
       } catch (error) {
            return this.applicationExceptionHandler.returnException(PalletCapacityResponseModel, error);
       }
     }

      /**
     * gets all the Value of Packing Methods
     * @returns AllValue Packing MethodsResponseModel which returns all the Value Addition Types  along with status (true/false), errortype, errorCode, internal message which provides message to the calling function.
     */

    @Post('/getAllPalletCapacitys')
    async getAllPalletCapacitys(): Promise<AllPalletCapacityResponseModel> {
        try {
            return await this.palletCapacityService.getAllPalletCapacitys();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllPalletCapacityResponseModel, error);
        }
    }

     /**
     * Activate Or De-Activate Value PalletCapacity
     * @param getSinglePalletCapacity PalletCapacityResponseModel 
     * @returns Value PalletCapacity
     */
   @Post('/activateOrDeactivatePalletCapacity')
   async activateOrDeactivatePalletCapacity(@Body() productReq: PalletCapacityRequest): Promise<PalletCapacityResponseModel> {
       try {
           return await this.palletCapacityService.activateOrDeactivatePalletCapacity(productReq);
       } catch (err) {
           return this.applicationExceptionHandler.returnException(PalletCapacityResponseModel, err);
       }
   }

    /**
     * creates or updates a value of PalletCapacity
     * @param PalletCapacityDto PalletCapacity DTO
     * @returns PalletCapacityResponse
     */
     @Post('/updatePalletCapacity')
     async updatePalletCapacity(@Body() PalletCapacityDto:PalletCapacityDTO,isUpdate:boolean=true,@Req() request:Request): Promise<PalletCapacityResponseModel> {
         try {
          return await this.palletCapacityService.createPalletCapacity(PalletCapacityDto,true,request);
        } catch (error) {
             return this.applicationExceptionHandler.returnException(PalletCapacityResponseModel, error);
        }
      }

      
}
